<!-- Modal (Depósito) -->

<ng-template #deposito let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-deposito"><b>Depósito</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <!-- De -->

    @if (!contaCorrenteSaldoSelecionado.is_manager || ((is_master || is_diretor) && !contaCorrenteSaldoSelecionado.is_manager)) {
      <div class="form-row">
        <div class="form-group col-sm-10">
          <label><b>De:</b></label>
          <select class="form-control form-control-sm" name="deposito_de" #deposito_de (change)="selecionarDepositoDe(deposito_de.value)" [ngClass]="{ 'is-invalid': depositoEnviado && depositoDeSelecionadoErro }">
            @for (opcao of contasCorrentesSaldo; track opcao) {
              <option [value]="opcao.id" [selected]="depositoDeSelecionado != null ? opcao.id == depositoDeSelecionado.id : null" [disabled]="opcao.id == contaCorrenteSaldoSelecionado.id" [hidden]="opcao.id == contaCorrenteSaldoSelecionado.id">{{ opcao.fullname }}</option>
            }
          </select>
          @if (depositoEnviado && depositoDeSelecionadoErro) {
            <div class="erro pt-1">De em branco!</div>
          }
        </div>
        <div class="col-sm-2 text-right">
          <h6 class="text-secondary"><b>Saldo Atual: R$</b></h6>
          <h6><b>{{ depositoDeSelecionado.saldo_final | currency: 'BRL' }}</b></h6>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
    }

    <!-- Para -->

    <div class="row">
      <div [ngClass]="contaCorrenteSaldoSelecionado.is_manager ? 'col-sm-8' : 'col-sm-10'">
        <h6 class="text-secondary"><b>Para:</b></h6>
        <h6><b>{{ contaCorrenteSaldoSelecionado.fullname }}</b></h6>
      </div>

      <div class="col-sm-2 text-right">
        <h6 class="text-secondary"><b>Saldo Atual: R$</b></h6>
        <h6><b>{{ contaCorrenteSaldoSelecionado.saldo_final | currency: 'BRL' }}</b></h6>
      </div>

      @if (contaCorrenteSaldoSelecionado.is_manager) {
        <div class="col-sm-2 text-right">
          <h6 class="text-secondary"><b>Saldo Distribuído: R$</b></h6>
          <h6><b>{{ contaCorrenteSaldoSelecionado.saldo_distribuido | currency: 'BRL' }}</b></h6>
        </div>
      }
    </div>

    <hr class="mt-2 mb-2" />

    <!-- Detalhes/Valor -->

    <form [formGroup]="formDeposito">
      <div class="form-row">
        <div class="form-group col-sm-10">
          <label><b>Detalhes:</b></label>

          <input class="form-control form-control-sm" type="text" name="detalhes" formControlName="detalhes" />
        </div>

        <div class="form-group col-sm-2">
          <label><b>Valor: R$</b></label>

          <input class="form-control form-control-sm" type="number" name="valor" [ngClass]="{ 'is-invalid': depositoEnviado && (fd.valor.errors?.required || depositoValorErro) }" (focusout)="validarDepositoValorErro()" (input)="validarDepositoValorErro()" formControlName="valor" />

          @if (depositoEnviado && fd.valor.errors?.required) {
            <div class="erro pt-1">Valor em branco!</div>
          }
          @if (depositoEnviado && depositoValorErro) {
            <div class="erro pt-1">Valor inválido!</div>
          }
        </div>
      </div>
    </form>

    <!-- Categoria -->

    <div class="row">
      <div class="form-group col-sm-12">
        <label><b>Categoria:</b></label>

        <select class="form-control form-control-sm" name="deposito_categoria" #deposito_categoria (change)="selecionarCategoria(deposito_categoria.value)">
          <option value="0"></option>

          @for (opcao of contasCorrentesCategoria; track opcao) {
            <option [value]="opcao.id" [selected]="contasCorrentesCategoriaSelecionada != null ? opcao.id == contasCorrentesCategoriaSelecionada.id : null">{{ opcao.nome }}</option>
          }
        </select>
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Salvar')">Salvar</button>
  </div>
</ng-template>

<!-- Modal (Extrato) -->

<ng-template #extrato let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-extrato"><b>Extrato</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div [ngClass]="contaCorrenteSaldoSelecionado.is_manager ? 'col-sm-8' : 'col-sm-10'">
        <h6 class="text-secondary"><b>{{ contaCorrenteSaldoSelecionado.is_manager ? 'Gestor(a)' : 'Vendedor(a)' }}:</b></h6>
        <h6><b>{{ contaCorrenteSaldoSelecionado.fullname }}</b></h6>
      </div>

      <div class="col-sm-2 text-right">
        <h6 class="text-secondary"><b>Saldo Atual: R$</b></h6>
        <h6><b>{{ contaCorrenteSaldoSelecionado.saldo_final | currency: 'BRL' }}</b></h6>
      </div>

      @if (contaCorrenteSaldoSelecionado.is_manager) {
        <div class="col-sm-2 text-right">
          <h6 class="text-secondary"><b>Saldo Distribuído: R$</b></h6>
          <h6><b>{{ contaCorrenteSaldoSelecionado.saldo_distribuido | currency: 'BRL' }}</b></h6>
        </div>
      }
    </div>

    <hr class="mt-2 mb-2" />

    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th class="text-center">Data/Hora</th>
            <th class="tabela_borda">Detalhes</th>
            <th class="tabela_borda">Categoria</th>
            <th class="text-right tabela_borda">Valor: R$</th>
            <th class="text-right tabela_borda">Saldo: R$</th>
          </tr>
        </thead>

        <tbody>
          @for (contaCorrenteExtrato of contasCorrentesExtrato; track contaCorrenteExtrato) {
            <tr>
              <td class="text-center">{{ contaCorrenteExtrato.data_transacao | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td class="tabela_borda">{{ contaCorrenteExtrato.detalhes_transacao }}</td>
              <td class="tabela_borda">{{ contaCorrenteExtrato.nome_categoria }}</td>
              <td class="text-right tabela_borda">{{ contaCorrenteExtrato.valor_transacao | currency: 'BRL' }}</td>
              <td class="text-right tabela_borda">{{ contaCorrenteExtrato.saldo_final | currency: 'BRL' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Retirada) -->

<ng-template #retirada let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-retirada"><b>Retirada</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <!-- De -->

    <div class="row">
      <div [ngClass]="contaCorrenteSaldoSelecionado.is_manager ? 'col-sm-8' : 'col-sm-10'">
        <h6 class="text-secondary"><b>De:</b></h6>
        <h6><b>{{ contaCorrenteSaldoSelecionado.fullname }}</b></h6>
      </div>

      <div class="col-sm-2 text-right">
        <h6 class="text-secondary"><b>Saldo Atual: R$</b></h6>
        <h6><b>{{ contaCorrenteSaldoSelecionado.saldo_final | currency: 'BRL' }}</b></h6>
      </div>

      @if (contaCorrenteSaldoSelecionado.is_manager) {
        <div class="col-sm-2 text-right">
          <h6 class="text-secondary"><b>Saldo Distribuído: R$</b></h6>
          <h6><b>{{ contaCorrenteSaldoSelecionado.saldo_distribuido | currency: 'BRL' }}</b></h6>
        </div>
      }
    </div>

    <hr class="mt-2 mb-2" />

    <!-- Para -->

    @if (!contaCorrenteSaldoSelecionado.is_manager || ((is_master || is_diretor) && !contaCorrenteSaldoSelecionado.is_manager)) {
      <div class="form-row">
        <div class="form-group col-sm-10">
          <label><b>Para:</b></label>
          <select class="form-control form-control-sm" name="retirada_para" #retirada_para (change)="selecionarRetiradaPara(retirada_para.value)" [ngClass]="{ 'is-invalid': retiradaEnviada && retiradaParaSelecionadoErro }">
            @for (opcao of contasCorrentesSaldo; track opcao) {
              <option [value]="opcao.id" [selected]="retiradaParaSelecionado != null ? opcao.id == retiradaParaSelecionado.id : null" [disabled]="opcao.id == contaCorrenteSaldoSelecionado.id" [hidden]="opcao.id == contaCorrenteSaldoSelecionado.id">{{ opcao.fullname }}</option>
            }
          </select>
          @if (retiradaEnviada && retiradaParaSelecionadoErro) {
            <div class="erro pt-1">Para em branco!</div>
          }
        </div>
        <div class="col-sm-2 text-right">
          <h6 class="text-secondary"><b>Saldo Atual: R$</b></h6>
          <h6><b>{{ retiradaParaSelecionado.saldo_final | currency: 'BRL' }}</b></h6>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
    }

    <!-- Detalhes/Valor -->

    <form [formGroup]="formRetirada">
      <div class="form-row">
        <div class="form-group col-sm-10">
          <label><b>Detalhes:</b></label>

          <input class="form-control form-control-sm" type="text" name="detalhes" formControlName="detalhes" />
        </div>

        <div class="form-group col-sm-2">
          <label><b>Valor: R$</b></label>

          <input class="form-control form-control-sm" type="number" name="valor" [ngClass]="{ 'is-invalid': retiradaEnviada && (fr.valor.errors?.required || retiradaValorErro) }" (focusout)="validarRetiradaValorErro()" (input)="validarRetiradaValorErro()" formControlName="valor" />

          @if (retiradaEnviada && fr.valor.errors?.required) {
            <div class="erro pt-1">Valor em branco!</div>
          }

          @if (retiradaEnviada && retiradaValorErro) {
            <div class="erro pt-1">Valor inválido!</div>
          }
        </div>
      </div>
    </form>

    <!-- Categoria -->

    <div class="row">
      <div class="form-group col-sm-12">
        <label><b>Categoria:</b></label>

        <select class="form-control form-control-sm" name="retirada_categoria" #retirada_categoria (change)="selecionarCategoria(retirada_categoria.value)">
          <option value="0"></option>

          @for (opcao of contasCorrentesCategoria; track opcao) {
            <option [value]="opcao.id" [selected]="contasCorrentesCategoriaSelecionada != null ? opcao.id == contasCorrentesCategoriaSelecionada.id : null">{{ opcao.nome }}</option>
          }
        </select>
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Salvar')">Salvar</button>
  </div>
</ng-template>

@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          <div class="titulo_texto">Conta Corrente</div>
        </div>
      </div>
    </div>
    <!-- Dados -->
    <div class="pt-3 pr-4 pb-4 pl-4">
      <div class="table-responsive">
        <table class="table table-sm">
          <thead>
            <tr>
              <th></th>
              <th class="tabela_borda"></th>
              <th class="tabela_borda"></th>
              <th class="tabela_borda"></th>
              <th class="tabela_borda">Gestor(a)</th>
              <th class="text-right tabela_borda">Saldo Atual: R$</th>
              <th class="text-right tabela_borda">Saldo Distribuído: R$</th>
            </tr>
          </thead>
          <tbody>
            @for (contaCorrenteSaldoAgrupada of contasCorrentesSaldoAgrupadas; track contaCorrenteSaldoAgrupada; let i = $index) {
              <tr>
                <td class="text-center tabela_acao">
                  <i class="fa  btn_tabela_acao" [ngClass]="i == gestorExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandir(i)"></i>
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  <i class="fa fa-envelope-open btn_tabela_acao" placement="right" ngbTooltip="Extrato" (click)="modalExtrato(extrato, contaCorrenteSaldoAgrupada)"></i>
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  @if (is_master || is_diretor) {
                    <i class="fa fa-plus btn_tabela_acao" placement="right" ngbTooltip="Depósito" (click)="modalDeposito(deposito, true, contaCorrenteSaldoAgrupada)"></i>
                  }
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  @if (is_master || is_diretor) {
                    <i class="fa fa-minus btn_tabela_acao" placement="right" ngbTooltip="Retirada" (click)="modalRetirada(retirada, true, contaCorrenteSaldoAgrupada)"></i>
                  }
                </td>
                <td class="tabela_borda">{{ contaCorrenteSaldoAgrupada.fullname }}</td>
                <td class="text-right tabela_borda">{{ contaCorrenteSaldoAgrupada.saldo_final | currency: 'BRL' }}</td>
                <td class="text-right tabela_borda">{{ contaCorrenteSaldoAgrupada.saldo_distribuido | currency: 'BRL' }}</td>
              </tr>
              @if (i == gestorExpandido) {
                <tr [@esvanecerDesvanecer]="'in'">
                  <td class="p-3" colspan="7">
                    <table class="table table-sm table-hover">
                      <thead>
                        <tr>
                          <th></th>
                          <th class="tabela_borda"></th>
                          <th class="tabela_borda"></th>
                          <th class="tabela_borda">Vendedor(a)</th>
                          <th class="text-right tabela_borda">Saldo Atual: R$</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (vendedor_vinculado of contaCorrenteSaldoAgrupada.vendedores_vinculados; track vendedor_vinculado) {
                          <tr>
                            <td class="text-center tabela_acao">
                              <i class="fa fa-envelope-open btn_tabela_acao" placement="right" ngbTooltip="Extrato" (click)="modalExtrato(extrato, vendedor_vinculado)"></i>
                            </td>
                            <td class="text-center tabela_acao tabela_borda">
                              <i class="fa fa-plus btn_tabela_acao" placement="right" ngbTooltip="Depósito" (click)="modalDeposito(deposito, true, vendedor_vinculado)"></i>
                            </td>
                            <td class="text-center tabela_acao tabela_borda">
                              <i class="fa fa-minus btn_tabela_acao" placement="right" ngbTooltip="Retirada" (click)="modalRetirada(retirada, true, vendedor_vinculado)"></i>
                            </td>
                            <td class="tabela_borda">{{ vendedor_vinculado.fullname }}</td>
                            <td class="text-right tabela_borda">{{ vendedor_vinculado.saldo_final | currency: 'BRL' }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
